module.exports = __webpack_public_path__ + "02_veryshort_black.7bd1d65e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer5/02_veryshort_black.png
// module id = e1Jj
// module chunks = 0